<template>
  <div class="box-border flex items-center h-screen w-screen  
        justify-center bg-gradient-to-l 
        from-teal-600 to-blue-900">
    <UContainer class="flex flex-col gap-8 justify-center items-center min-h-screen">
      <div class="mt-6 h-27 shrink-0" >
          <LogoIcon class="h-16 w-auto text-white z-1000 shrink-0" />
      </div>
      <div class="mt-7 shrink-0" >
        <UCard class="min-w-80 max-w-96 shadow-lg static ">
            <h1 class="text-7xl font-bold text-red-600">{{ error.statusCode }}</h1>
            <p class="text-xl mt-4">{{ error.statusMessage }}</p>
          
            <div class="mt-10">
              <UButton to="/" color="neutral" variant="solid" block><Icon name="lucide:home" />
                Volver a inicio
              </UButton>
            </div>
        </UCard>
      </div>
    </UContainer>
  </div>
</template>


<script setup lang="ts">
import type { NuxtError } from "#app";
import LogoIcon from '~/assets/3a-logo-core-materials.svg'
if (process.client && useError()) {
  definePageMeta({ layout: false })
}

const props = defineProps<{ error: NuxtError }>()
</script>

<style></style>